import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { ListStatus } from "@/constants/default";
import { FormProvider, useForm } from "react-hook-form";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import Information from "./_information";
import { BusinessUnitForm } from "@/types/businessunit.type";
import { useEditBusinessUnitMutation, useGetBusinessUnitQuery } from "@/services/businessunit.service";
import { formatDateTimeAutoToString } from "@/utils/format";
import moment from "moment-timezone";

export default function EditBusinessUnit() {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const listStatus = ListStatus();
    const [editBusinessUnit, {isSuccess}] = useEditBusinessUnitMutation()
    const {data: businessunit} = useGetBusinessUnitQuery(location.state?.id || "", {refetchOnMountOrArgChange: true})
    const methods = useForm<BusinessUnitForm>()
    const {handleSubmit, setValue} = methods

    const onSubmit = handleSubmit(async (data) => {
        if(businessunit) {
            let take_over = businessunit.take_over
            if (formatDateTimeAutoToString(take_over, "YYYY-MM-DD") !== data.take_over) {
                let now = moment();
                take_over = moment(`${data.take_over} ${now.hours()}:${now.minutes()}:${now.seconds()}.${now.milliseconds()}`, 'YYYY-MM-DD HH:mm:ss.SSS').toISOString()
            }
            editBusinessUnit({...{
                    ...data,
                    take_over: take_over
                },
                id: businessunit?.id,
            })
        }
    })

    useEffect(() => {
        if (businessunit) {
            setValue("company_id", businessunit.company_id)
            setValue("status", _.find(listStatus, item => item.value === businessunit.status)?.value || listStatus[0].value)
            setValue("name", businessunit.name)
            setValue("account", businessunit.account)
            setValue("description", businessunit.description)
            setValue("take_over",  formatDateTimeAutoToString(businessunit.take_over, "YYYY-MM-DD"))
            setValue("landlord_name", businessunit.landlord_name)
            setValue("address", businessunit.address)
            setValue("condo", businessunit.condo)
            setValue("unit", businessunit.unit)
            setValue("door_pin", businessunit.door_pin)
            setValue("condo_card", businessunit.condo_card)
            setValue("bank", businessunit.bank)
            setValue("bank_account", businessunit.bank_account)
            setValue("rooms", businessunit.rooms)
        }
    }, [businessunit])

    useEffect(() => {
        if(isSuccess) {
            navigate(location, {state: {reload: true}})
        }
    }, [isSuccess])

    return (
        <div x-show="modalOpen" x-transition="" className="fixed top-0 left-0 z-99999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5">
            <div className="w-full max-w-screen-lg rounded-lg bg-white py-5 px-8 dark:bg-boxdark">
                <h3 className="text-xl dark:text-white text-center font-medium my-5">
                    {t("businessunit.edit_business_unit")}
                </h3>
                <form className="mx-5" onSubmit={onSubmit}>
                    <FormProvider {...methods}>
                        <Information />
                    </FormProvider>
                    <div className="flex justify-end pt-3">
                        <div className="px-3">
                            <button type="button" onClick={() => navigate(location)} className="block w-full rounded border border-stroke bg-gray-400 p-1.5 px-3 text-center font-medium text-black transition hover:bg-opacity-90">
                                {t("modal.cancel")}
                            </button>
                        </div>
                        <div>
                            <button type="submit" className="flex w-full justify-center rounded bg-primary p-1.5 px-3 text-white hover:bg-opacity-90">
                                {t("modal.submit")}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
